import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginView } from '@es-tools/shared';
import { getBrandConfig, getCurrentBrand } from '../brand-config';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const allowDevBypass = import.meta.env.VITE_DEV_BYPASS_AUTH === 'true';
  const currentBrand = getCurrentBrand();
  const brandConfig = getBrandConfig();

  const loginContent = (() => {
    if (currentBrand === 'marsmen') {
      return {
        title: 'Welcome to Mars Men Automation',
        subtitle: 'Sign in to access Mars Men dashboards, workflows, and the data platform.',
        logoPrefix: 'MM',
        logoText: 'Mars Men',
        supportText: 'Authorized Mars Men team members only',
        accessDeniedText: 'Access denied. Please sign in with an approved Mars Men Google Workspace account.',
        brandLinks: [{ label: 'Mars Men', href: 'https://mengotomars.com' }],
      };
    }

    if (currentBrand === 'hollow') {
      return {
        title: 'Welcome to Hollow Socks Automation',
        subtitle: 'Sign in to access Hollow Socks dashboards, workflows, and automation tools.',
        logoPrefix: 'HS',
        logoText: 'Hollow Socks',
        supportText: 'Authorized Hollow Socks team members only',
        accessDeniedText: 'Access denied. Please sign in with an approved Hollow Socks Google Workspace account.',
        brandLinks: [{ label: 'Hollow Socks', href: 'https://hollowsocks.com' }],
      };
    }

    return {
      title: `Welcome to ${brandConfig.name} Automation`,
      subtitle: `Sign in to access ${brandConfig.name} dashboards, workflows, and automation tools.`,
      logoPrefix: 'AT',
      logoText: 'Automation',
      supportText: `Authorized ${brandConfig.name} team members only`,
      accessDeniedText: `Access denied. Please sign in with an approved ${brandConfig.name} Google Workspace account.`,
      brandLinks: [],
    };
  })();

  return (
    <LoginView
      allowDevBypass={allowDevBypass}
      title={loginContent.title}
      subtitle={loginContent.subtitle}
      logoPrefix={loginContent.logoPrefix}
      logoText={loginContent.logoText}
      supportText={loginContent.supportText}
      accessDeniedText={loginContent.accessDeniedText}
      brandLinks={loginContent.brandLinks}
      onLoginSuccess={() => navigate('/')}
    />
  );
};

export default Login;
